const n = (id, type, x, y, data = {}) => ({ id, type, position: { x, y }, data });
/** "source.exit>target" */
const e = (spec) => {
    const [from, target] = spec.split('>');
    const dot = from.indexOf('.');
    return { id: `${from}>${target}`, source: from.slice(0, dot), sourceHandle: from.slice(dot + 1), target };
};
export const flowTemplates = [
    {
        id: 'menu-hours-queue-voicemail',
        name: 'Menu, opening hours, queue, voicemail',
        description: 'Open: a menu sends callers to Sales (1) or Support (2). Closed, or nobody answers: a message.',
        graph: {
            nodes: [
                n('start', 'start', 340, 0),
                n('hours', 'hours', 340, 150, { label: 'Office hours' }),
                n('welcome', 'menu', 120, 330, { label: 'Welcome menu', keys: ['1', '2'], timeoutSeconds: 5 }),
                n('sales', 'queue', -200, 530, { label: 'Sales' }),
                n('support', 'queue', 200, 530, { label: 'Support' }),
                n('closed', 'play', 720, 330, { label: 'We are closed' }),
                n('voicemail', 'voicemail', 720, 760, { label: 'Message', voicemailFor: 'queue' }),
                n('thanks', 'play', 100, 760, { label: 'We will call you back' }),
                n('bye', 'hangup', 100, 920),
            ],
            edges: [
                e('start.next>hours'),
                e('hours.open>welcome'),
                e('hours.closed>closed'),
                e('closed.next>voicemail'),
                e('welcome.key:1>sales'),
                e('welcome.key:2>support'),
                e('welcome.invalid>welcome'),
                e('welcome.timeout>support'),
                e('sales.timeout>voicemail'),
                e('sales.nobody>voicemail'),
                e('sales.callback>thanks'),
                e('support.timeout>voicemail'),
                e('support.nobody>voicemail'),
                e('support.callback>thanks'),
                e('thanks.next>bye'),
            ],
        },
    },
    {
        id: 'tech-and-sales',
        name: 'Tech line with sales hours',
        description: 'A menu: 1, no key or a wrong key go to Tech; 2 goes to Sales while Sales is open, else to Tech. Unanswered callers get a callback.',
        graph: {
            nodes: [
                n('start', 'start', 320, 0),
                n('menu', 'menu', 300, 150, { label: 'Main menu', keys: ['1', '2'], timeoutSeconds: 5 }),
                n('salesHours', 'hours', 640, 330, { label: 'Sales hours' }),
                n('tech', 'queue', 80, 540, { label: 'Tech' }),
                n('sales', 'queue', 600, 540, { label: 'Sales' }),
                n('callback', 'callback', 340, 760, { label: 'Call back' }),
                n('thanks', 'play', 340, 930, { label: 'We will call you back' }),
                n('bye', 'hangup', 340, 1090),
            ],
            edges: [
                e('start.next>menu'),
                e('menu.key:1>tech'),
                e('menu.invalid>tech'),
                e('menu.timeout>tech'),
                e('menu.key:2>salesHours'),
                e('salesHours.open>sales'),
                e('salesHours.closed>tech'),
                e('tech.timeout>callback'),
                e('tech.nobody>callback'),
                e('tech.callback>thanks'),
                e('sales.timeout>callback'),
                e('sales.nobody>callback'),
                e('sales.callback>thanks'),
                e('callback.next>thanks'),
                e('thanks.next>bye'),
            ],
        },
    },
    {
        id: 'hours-queue-voicemail',
        name: 'Opening hours, queue, voicemail',
        description: 'One queue while open; a closed message and voicemail otherwise, or when nobody answers.',
        graph: {
            nodes: [
                n('start', 'start', 260, 0),
                n('hours', 'hours', 260, 150, { label: 'Opening hours' }),
                n('queue', 'queue', 0, 330, { label: 'Team' }),
                n('closed', 'play', 480, 330, { label: 'We are closed' }),
                n('voicemail', 'voicemail', 320, 540, { label: 'Message', voicemailFor: 'queue' }),
                n('bye', 'hangup', 0, 540),
            ],
            edges: [
                e('start.next>hours'),
                e('hours.open>queue'),
                e('hours.closed>closed'),
                e('closed.next>voicemail'),
                e('queue.timeout>voicemail'),
                e('queue.nobody>voicemail'),
                e('queue.callback>bye'),
            ],
        },
    },
];
